export default __webpack_public_path__ + "static/media/pathology.a272f717.png";